import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconGameRoom: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        xmlns: 'http://www.w3.org/2000/svg',
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12 22c-.3 0-.5-.1-.7-.3L9 19.4c-1.2 1.2-3.2 1.2-4.4 0-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.8-2.2l-2.3-2.3c-.4-.4-.4-1 0-1.4l3.2-3.2c.3-.3.6-.3 1-.3.3.1.6.4.7.7.1.2.2.4.4.5.4.5 1.1.5 1.5 0 .2-.2.3-.5.3-.8 0-.3 0-.5-.3-.7-.1-.2-.3-.3-.5-.3-.3-.1-.6-.4-.7-.7-.1-.3 0-.7.3-1l3.2-3.2c.4-.4 1-.4 1.4 0L15 4.6c1.2-1.2 3.2-1.2 4.4 0 .6.6.9 1.4.9 2.2 0 .8-.3 1.6-.8 2.2l2.3 2.3c.4.4.4 1 0 1.4l-3.2 3.2c-.3.3-.6.3-1 .3-.3-.1-.6-.4-.7-.7-.1-.2-.1-.4-.3-.5-.4-.4-1.1-.4-1.6 0-.2.2-.3.5-.3.8 0 .3.1.6.3.8.1.1.3.2.5.3.3.1.6.4.7.7.1.3 0 .7-.3 1l-3.2 3.2c-.2.1-.4.2-.7.2zm-3.2-5.2c.3 0 .5.1.7.3l2.5 2.5 1.6-1.6c-.6-.6-.9-1.4-.9-2.2 0-.8.3-1.6.9-2.2 1.2-1.2 3.2-1.2 4.4 0l1.6-1.6-2.5-2.5c-.3-.3-.4-.6-.3-1 .1-.3.4-.6.7-.7.2-.1.4-.1.5-.3.2-.2.3-.5.3-.8 0-.3 0-.5-.3-.7-.4-.4-1.1-.4-1.6 0-.1.1-.2.3-.3.5-.1.3-.4.6-.7.7-.3.1-.7 0-1-.3L12 4.4 10.4 6c.6.6 1 1.4 1 2.2 0 .8-.3 1.6-.9 2.2-1.3 1.3-3.2 1.3-4.5.1L4.4 12l2.5 2.5c.3.3.4.6.3 1-.1.3-.4.6-.7.7-.2.1-.4.1-.5.3-.2.2-.3.5-.3.8 0 .3 0 .5.3.7.4.4 1.1.4 1.6 0 .1-.1.2-.3.3-.5.1-.3.4-.6.7-.7h.2z',
    })
  )
}
